import React from "react";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";

const DetailTrimestreFP = ({ InfosTrimestres }) => {
  const tabAssurance = InfosTrimestres?.TabTrimestreDureeAssuranceFonctionPublique || {};
  const tabService = InfosTrimestres?.TabTrimestreServiceEffectifFonctionPublique || {};

  let TotalAssuranceTrimestre = 0;
  let TotalAssuranceJours = 0;
  let TotalServiceTrimestre = 0;
  let TotalServiceJours = 0;

  for (const annee in tabAssurance) {
    TotalAssuranceTrimestre += tabAssurance[annee]["Trimestre"] || 0;
    TotalAssuranceJours += tabAssurance[annee]["JourRestant"] || 0;
  }
  for (const annee in tabService) {
    TotalServiceTrimestre += tabService[annee]["Trimestre"] || 0;
    TotalServiceJours += tabService[annee]["JourRestant"] || 0;
  }

  const allYears = [...new Set([...Object.keys(tabAssurance), ...Object.keys(tabService)])].sort();

  return (
    <Column fill>
      <CardBox>
        <Column fill>
          <Row>
            <div className="revenuspro-container">
              {/* Header avec 2 lignes */}
              <div className="header-card" style={{ flexDirection: "row", minHeight: "auto" }}>
                {/* Colonne Année centrée sur les 2 lignes */}
                <div className="category-column" style={{ maxWidth: "120px", color: "#ffffff", fontWeight: "700", alignItems: "center", justifyContent: "center", textAlign: "center" }}>
                  Année
                </div>
                {/* Colonnes droites : 2 lignes empilées */}
                <div style={{ display: "flex", flexDirection: "column", flex: 1, borderLeft: "1px solid rgba(255,255,255,0.3)" }}>
                  {/* Ligne 1 : groupes */}
                  <div style={{ display: "flex", width: "100%" }}>
                    <div className="value-column" style={{ flex: 2, color: "#ffffff", fontWeight: "700", justifyContent: "center" }}>
                      Durée d'assurance
                    </div>
                    <div className="value-column" style={{ flex: 2, color: "#ffffff", fontWeight: "700", borderLeft: "1px solid rgba(255,255,255,0.3)", justifyContent: "center" }}>
                      Durée de service
                    </div>
                  </div>
                  {/* Ligne 2 : sous-colonnes */}
                  <div style={{ display: "flex", width: "100%", borderTop: "1px solid rgba(255,255,255,0.3)" }}>
                    <div className="value-column" style={{ color: "#ffffff", fontWeight: "600", justifyContent: "center" }}>
                      Trimestre
                    </div>
                    <div className="value-column" style={{ color: "#ffffff", fontWeight: "600", justifyContent: "center" }}>
                      Jours
                    </div>
                    <div className="value-column" style={{ color: "#ffffff", fontWeight: "600", borderLeft: "1px solid rgba(255,255,255,0.3)", justifyContent: "center" }}>
                      Trimestre
                    </div>
                    <div className="value-column" style={{ color: "#ffffff", fontWeight: "600", justifyContent: "center" }}>
                      Jours
                    </div>
                  </div>
                </div>
              </div>

              {/* Conteneur des cartes de contenu */}
              <div className="card-list-container">
                {allYears.map((annee, index) => {
                  const assurance = tabAssurance[annee] || {};
                  const service = tabService[annee] || {};
                  return (
                    <div key={"DetailTrimestreFP" + index} className="card">
                      <div className="category-column" style={{ maxWidth: "120px" }}>
                        <span className="trimester-year-badge">{annee}</span>
                      </div>
                      <div className="value-column" style={{ justifyContent: "center" }}>
                        {assurance["Trimestre"] ?? ""}
                      </div>
                      <div className="value-column" style={{ justifyContent: "center" }}>
                        {assurance["JourRestant"] ?? ""}
                      </div>
                      <div className="value-column" style={{ justifyContent: "center", borderLeft: "2px solid #e2e8f0" }}>
                        {service["Trimestre"] ?? ""}
                      </div>
                      <div className="value-column" style={{ justifyContent: "center" }}>
                        {service["JourRestant"] ?? ""}
                      </div>
                    </div>
                  );
                })}

                {/* Carte récapitulative Total */}
                <div className="card" style={{ backgroundColor: "#f3f4f6", fontWeight: "600" }}>
                  <div className="category-column" style={{ fontWeight: "600", textAlign: "center", maxWidth: "120px" }}>
                    <span>Total</span>
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {TotalAssuranceTrimestre}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {TotalAssuranceJours}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center", borderLeft: "2px solid #e2e8f0" }}>
                    {TotalServiceTrimestre}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {TotalServiceJours}
                  </div>
                </div>
              </div>

              <div className="header-card tpad" style={{ flexDirection: "row", minHeight: "auto" }}>
                {/* Colonne Année centrée sur les 2 lignes */}
                <div
                  className="category-column"
                  style={{ maxWidth: "330px", color: "#ffffff", fontWeight: "700", alignItems: "center", justifyContent: "center", textAlign: "center" }}
                ></div>
                {/* Colonnes droites : 2 lignes empilées */}
                <div style={{ display: "flex", flexDirection: "column", flex: 1, borderLeft: "1px solid rgba(255,255,255,0.3)" }}>
                  {/* Ligne 1 : groupes */}
                  <div style={{ display: "flex", width: "100%" }}>
                    <div className="value-column" style={{ flex: 2, color: "#ffffff", fontWeight: "700", justifyContent: "center" }}>
                      Durée d'assurance
                    </div>
                    <div className="value-column" style={{ flex: 2, color: "#ffffff", fontWeight: "700", borderLeft: "1px solid rgba(255,255,255,0.3)", justifyContent: "center" }}>
                      Durée de service
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-list-container">
                <div className="card">
                  <div className="category-column" style={{ maxWidth: "330px" }}>
                    Trimestres non affectés à des années civiles
                  </div>
                  <div className="value-column" style={{ justifyContent: "center", borderLeft: "2px solid #e2e8f0" }}>
                    {InfosTrimestres?.TrimestreSupplementaireDureeAssuranceFonctionPubliqueReel || 0}
                  </div>
                  <div className="value-column" style={{ justifyContent: "center" }}>
                    {InfosTrimestres?.TrimestreSupplementaireServiceEffectifFonctionPubliqueReel || 0}
                  </div>
                </div>
                <div className="card">
                  <div className="category-column" style={{ maxWidth: "330px" }}>
                    Jours restants non affectés à des années civiles
                  </div>
                  <div className="value-column" style={{ justifyContent: "center", borderLeft: "2px solid #e2e8f0" }}>
                    {InfosTrimestres?.JourRestantDureeAssuranceFonctionPubliqueReel || 0}
                  </div>
                  <div className="value-column" style={{ justifyContent: "center" }}>
                    {InfosTrimestres?.JourRestantServiceEffectifFonctionPubliqueReel || 0}
                  </div>
                </div>
              </div>
                          {/* Conteneur des cartes de contenu */}
                <div className="card-list-container tpad">
                  {/* Carte récapitulative Total */}
                  <div className="card" style={{ backgroundColor: "#f3f4f6", fontWeight: "600" }}>
                    <div className="category-column" style={{ fontWeight: "600", textAlign: "center", maxWidth: "330px" }}>
                      <span>Total des trimestres</span>
                    </div>
                    <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                      {TotalAssuranceTrimestre+InfosTrimestres?.TrimestreSupplementaireDureeAssuranceFonctionPubliqueReel || 0}
                    </div>
                    <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                      {TotalServiceTrimestre+InfosTrimestres?.TrimestreSupplementaireServiceEffectifFonctionPubliqueReel || 0}
                    </div>
                  </div>
                </div>
            </div>
          </Row>
        </Column>
      </CardBox>
    </Column>
  );
};

export default DetailTrimestreFP;

//    <FormatLignePension
//   key={index++}
//   caisse={"RSI Commerçant"}
//   points={data[1]["General"]["TotalPoint"]}
//   valeurPoint={data[1]["General"]["ValeurPoint"]}
//   pensionTheo={data[1]["General"]["PensionTheorique"]}
//   coeff={data[1]["General"]["Coefficient"]}
//   majoEnfant={"-"}
//   pension={data[1]["General"]["Pension"]}
// />
